import { render, staticRenderFns } from "./GoogleSignInButton.vue?vue&type=template&id=a4f652da"
import script from "./GoogleSignInButton.vue?vue&type=script&lang=ts"
export * from "./GoogleSignInButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports